import { Tag, Tooltip, theme } from 'antd';

export interface PresencePillProps {
  present: boolean;
  label: string;
  /** Tag colour when present; `success` by default. */
  color?: string;
  tooltip?: string;
  /** Leading glyph; defaults to ✓ when present, – when absent. */
  mark?: string;
}

/** `✓ Label` in colour when present, muted `– Label` otherwise. */
export const PresencePill = ({
  present,
  label,
  color,
  tooltip,
  mark,
}: PresencePillProps) => {
  const { token } = theme.useToken();
  const tag = (
    <Tag
      color={present ? (color ?? 'success') : undefined}
      style={{
        marginInlineEnd: 0,
        color: present ? undefined : token.colorTextQuaternary,
      }}
    >
      {mark ?? (present ? '✓' : '–')} {label}
    </Tag>
  );
  return tooltip ? <Tooltip title={tooltip}>{tag}</Tooltip> : tag;
};
